import React, { useEffect, useState } from 'react';
import { Modal, Typography, Tag, message } from 'antd';
import { CheckOutlined, WarningOutlined } from '@ant-design/icons';
import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const SEVERIDADES = [
  { value: 'BAJA', label: 'Baja' },
  { value: 'MEDIA', label: 'Media' },
  { value: 'ALTA', label: 'Alta' },
  { value: 'CRITICA', label: 'Crítica' },
];

const CHIP_CLASSES = {
  BAJA: {
    filled: 'bg-emerald-500 border-emerald-500 text-white shadow-sm',
    outline:
      'bg-white border-emerald-200 text-emerald-700 hover:border-emerald-400',
  },
  MEDIA: {
    filled: 'bg-sky-500 border-sky-500 text-white shadow-sm',
    outline: 'bg-white border-sky-200 text-sky-700 hover:border-sky-400',
  },
  ALTA: {
    filled: 'bg-amber-500 border-amber-500 text-white shadow-sm',
    outline: 'bg-white border-amber-200 text-amber-700 hover:border-amber-400',
  },
  CRITICA: {
    filled: 'bg-rose-600 border-rose-600 text-white shadow-sm',
    outline: 'bg-white border-rose-200 text-rose-700 hover:border-rose-400',
  },
};

function HallazgosSeveridadModal({ target, onClose, onSuccess }) {
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (target) setSelected(target.severidad || null);
  }, [target]);

  const handleUpdate = async () => {
    if (!selected) {
      message.warning('Elegí una severidad');
      return;
    }
    if (selected === target.severidad) {
      onClose?.();
      return;
    }
    setLoading(true);
    try {
      await axios.patch(
        `${API_PATH}/actividades-hallazgo/${target.id}/severidad`,
        { severidad: selected },
        { headers: { Authorization: getAccessTokenApi() } }
      );
      message.success('Severidad actualizada');
      onSuccess?.();
    } catch (err) {
      message.error(
        err?.response?.data?.message || 'Error al actualizar la severidad'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={!!target}
      onCancel={onClose}
      onOk={handleUpdate}
      okText="Guardar"
      cancelText="Cancelar"
      okButtonProps={{ loading, disabled: !selected }}
      title={
        <div className="flex items-center gap-2">
          <WarningOutlined className="text-amber-500" />
          <span>Cambiar severidad</span>
        </div>
      }
      width={480}
      destroyOnHidden
    >
      {target && (
        <div className="space-y-4">
          <div className="rounded-xl bg-slate-50 p-4">
            <Tag color="red" className="mb-2">
              INCIDENCIA
            </Tag>
            <Typography.Text className="block text-sm text-slate-700">
              {target.descripcion || '(sin descripción)'}
            </Typography.Text>
          </div>
          <div>
            <label className="mb-2 block text-[11px] font-bold uppercase tracking-wider text-slate-500">
              Severidad
            </label>
            <div className="grid grid-cols-4 gap-2">
              {SEVERIDADES.map((opt) => {
                const isSelected = selected === opt.value;
                const cls = isSelected
                  ? CHIP_CLASSES[opt.value].filled
                  : CHIP_CLASSES[opt.value].outline;
                return (
                  <button
                    key={opt.value}
                    type="button"
                    onClick={() => setSelected(opt.value)}
                    className={`relative rounded-xl border-2 px-2 py-2.5 text-xs font-semibold transition-all duration-150 active:scale-[0.97] ${cls}`}
                  >
                    {opt.label}
                    {isSelected && (
                      <span className="absolute -right-1.5 -top-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-white shadow">
                        <CheckOutlined className="text-[8px] text-slate-700" />
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
}

export default HallazgosSeveridadModal;
